export class StatusPedidoModel {
    constructor(
        public codigo: number = 1,
        public descricao: string = ''
    ) { }
}